export default "__VITE_ASSET__6cqvQxwr__"